import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChangePassword, DeleteAccount } from '@/widgets';
import { MainSection } from '@/components/layout/MainSection';
import { useAccountContext } from '@/layouts/AccountLayout/context';

const SecurityTab: React.FC = () => {
  const { t } = useTranslation(['account']);
  const { user } = useAccountContext();

  return (
    <MainSection title={t('account:security')}>
      <div className="d-flex flex-column g-24">
        {user?.email && (
          <ChangePassword />
        )}
        <DeleteAccount />
      </div>
    </MainSection>
  );
};

export default SecurityTab;
